import { useState, useEffect } from "react";
import axios from "axios";
import API_URL from "../../../ApiUrl";
import Swal from "sweetalert2";
import { DemoFooter } from "../../../components/molecules";
import NavbarMenu from "../../../components/molecules/Navbar/Navbar";
import { Card, Container, FormGroup, Label,  } from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FaUser } from "react-icons/fa";

const schema = yup.object({
  nama_lengkap: yup.string().required("Nama Lengkap wajib diisi"),
  email: yup.string().email("Email tidak valid").required("Email wajib diisi"),
  no_telp: yup.string().required("Nomor Telpon wajib diisi"),
});

const GlobalAmbasador = ({ match }) => {

  const [notFound, setNotFound] = useState(false);
  const [dataGA, setDataGA] = useState({});
  const [btnText, setBtnText] = useState("Send");

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({ 
    resolver: yupResolver(schema),
    defaultValues: {
      nama_lengkap: "",
      email: "",
      no_telp: "",
    },    
  });  

  const name = watch("nama_lengkap");
  const email = watch("email");
  const province = watch("no_telp");

  const sendData = async () => {
    setBtnText("Sending ...");

    try {
      const fd = new FormData();
      fd.append("nama_lengkap", name);
      fd.append("email", email);
      fd.append("no_wa", province);
      fd.append("code_ambassador", dataGA.code_ambassador);

      const response = await axios.post(
        `${API_URL.superStudent}/ambassador/register-student`,
        fd,
        {
          headers: { Authorization: `Bearer ${API_URL.ambassadorKey}` },
        }
      );

      if (response.status === 200) {
        Swal.fire({
          title: "Pendaftaran Berhasil!",
          text: "Selamat!!, pendaftaran anda sudah berhasil.",
          icon: "success",
          confirmButtonText: "OK",
        })
        reset();
      } else {
        Swal.fire({
          title: "Register Failed",
          text: response.data.message || "Terjadi kesalahan.",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.href = "/";
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        title: "Register Failed",
        text: "Terjadi kesalahan koneksi. Silakan coba lagi.",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.href = "/";
      });
    } finally {
      setBtnText("Send");
    }
  };

  // --- FETCH AMBASSADOR PROFILE ---
  const getProfileAmbassador = async () => {
    try {
      const fd = new FormData();
      fd.append("username", match.params.username);

      const res = await axios.post(
        `${API_URL.superStudent}/ambassador/getAmbassador`,
        fd,
        {
          headers: { Authorization: `Bearer ${API_URL.ambassadorKey}` },
        }
      );

      const result = res.data.data.userable;
      if (!result) {
        setNotFound(true);
        return;
      }      
      setDataGA(result);
      // setWaNumber(`https://wa.me/62${result.phone.slice(1)}`);
    } catch (err) {
      console.error("Error fetching ambassador profile:", err);
      setNotFound(true);
    }
  };

  useEffect(() => {
    getProfileAmbassador();
  }, []);

  if (notFound) {
    return (
      <div className="form2">
        <Container>
          <h2 className="text-center text-white z-1 position-relative">Username Tidak Valid!</h2>
        </Container>
      </div>    
    )
  }

  return (
    <>
      <NavbarMenu />

      {/* REGISTER FORM */}
      <section id="form" className="form2">
        <Container>
          <div className="form-wrapper2">
            <div className="profile">
              {dataGA.foto? <img src={dataGA.foto} className="img-fluid rounded-circle" /> : <FaUser size={150} color="white"/>}
            </div>
            <h3 className="text-center text-white z-1 position-relative mb-3">Hai, {dataGA.name}</h3>
            <Card className="card-form p-4">
              <h3 className="text-center">Student Register</h3> 
              <form onSubmit={handleSubmit(sendData)}>
                <FormGroup>
                  <Label style={{ color: "black", fontWeight: "600" }}>
                    Nama Lengkap
                  </Label>
                  <input
                    {...register("nama_lengkap")}
                    className="form-control"
                    id="nama_lengkap"
                    placeholder="Masukan Nama Lengkap..."
                  />
                  <span style={{ color: "red" }}>{errors.nama_lengkap?.message}</span>
                </FormGroup>

                <FormGroup>
                  <Label style={{ color: "black", fontWeight: "600" }}>
                    Email
                  </Label>
                  <input
                    {...register("email")}
                    className="form-control"
                    id="email"
                    type="email"
                    placeholder="example@mail.com..."
                  />
                  <span style={{ color: "red" }}>{errors.email?.message}</span>
                </FormGroup>

                <FormGroup>
                  <Label style={{ color: "black", fontWeight: "600" }}>
                    No HP/WA
                  </Label>
                  <input
                    {...register("no_telp")}
                    className="form-control"
                    id="no_telp"
                    type="number"
                    placeholder="081..."
                  />
                  <span style={{ color: "red" }}>{errors.no_telp?.message}</span>
                </FormGroup>

                <div className="d-grid">
                  <input type="submit" value={btnText} className="btn-custom3"/>
                </div>            
              </form>
            </Card>
          </div>
        </Container>
      </section>

      <DemoFooter />
    </>
  );
};

export default GlobalAmbasador;